
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../auth.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {
  registerForm: FormGroup = new FormGroup({});
  loading = false;


  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    // Clear stale registration data from previous sessions
    localStorage.removeItem('referralCode');
    localStorage.removeItem('accountType');

    // Capture referral code from route params and store in localStorage
    this.route.paramMap.subscribe(params => {
      const referralCode = params.get('ref');
      if (referralCode) {
        // Persist the server-generated referral code for the registration flow
        localStorage.setItem('referralCode', referralCode);
      }
    });

    // Capture type query param to determine account type
    // Default to 'client' if no type specified
    this.route.queryParamMap.subscribe(params => {
      const accountType = params.get('type');
      if (accountType === 'model') {
        localStorage.setItem('accountType', 'model');
      } else {
        // Default to client for any other value or no value
        localStorage.setItem('accountType', 'client');
      }
    });

    this.registerForm = this.fb.group({
      displayName: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(50)]],
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(6)]],
      acceptGuidelines: [false, Validators.requiredTrue]
    });
  }

  register() {
    if (this.registerForm.invalid) {
      return;
    }
    this.loading = true;
    const { displayName, email, password } = this.registerForm.value;
    const registerResult = this.authService.register(email, password, displayName);
    if (registerResult && typeof registerResult.then === 'function') {
      registerResult.then(() => {
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    } else {
      this.loading = false;
    }
  }
}